import React, {Fragment, useContext} from "react";
import PropTypes from "prop-types";
import SpinnerDiv from "root/Components/SpinnerDiv";
import PassportTable, {xlateBootstrapTableColumns} from "root/Tables/PassportTable";
import {
    defaultTableHeaderStyles,
    defaultPaginationOptions,
    customHeaderStyle,
    defaultTopLeftCellStyle,
    defaultTopRightCellStyle,
    TableActionIconEmail,
    TableActionIconChart,
    TableActionIconSuspend,
    TableActionIconEdit,
    TableActionIconPassword,
    TableActionIconActivate,
    TableActionIconView,
    TableActionIconManage,
    TableActionIconDelete
} from "./BaseTableComponents";

import './Table.scss'
import {getMyContributorsRouterLink, getUsersRouterLink} from "root/Wieldy/routePaths";
import phpVars from 'phpVars';
import {UserGroupTypes, UserRoleGroups, UserTypes} from "root/DataFunctions/Constants";
import {ApplicationTypes, doesUserHaveApplication} from "root/DataFunctions/PageContentRoles";
import GlobalContext from "root/contexts/GlobalContext";

const ArchiveUsersTable = (props) =>
{
    const globals = useContext(GlobalContext);

    const onClickItem = (user_id, mode, role, name) =>
    {
        props.clickHandler(user_id,  mode, role, name);
    }

    const linkFormatter = (cell, row, rowIndex, formatExtraData) =>
    {
        const connectionsLink = getUsersRouterLink(row.idusers + '/connections?name=' + row.name);
        const usersDashboardLink = getUsersRouterLink(row.idusers + '/dashboard?type=summary&name=' + row.name + '&userType=' + row.userTypeId);
        const myContributorsDashboardLink = getMyContributorsRouterLink(row.idusers + '/dashboard?type=summary&name=' + row.name + '&userType=' + row.userTypeId);

        const isStaff = phpVars.user_type_group === UserGroupTypes.USER_GROUP_STAFF;
        const canManageUserRights = doesUserHaveApplication(ApplicationTypes.ORGANISATION_ADMIN, globals.userType) && UserRoleGroups.CAN_BE_STAFF.includes(+(row.userTypeId));

        return (
            <Fragment>
                {isStaff && <TableActionIconChart text="View User's Stats" to={usersDashboardLink} />}
                {!isStaff && <TableActionIconChart text="View Contributor's Stats" to={myContributorsDashboardLink} />}
                <TableActionIconEdit text="Edit User" onClick={() => onClickItem(row.idusers,'edit',  row.typeName)} />
                <TableActionIconEmail text="Invite Again" onClick={() => onClickItem(row.idusers, 'invite')} />
            </Fragment>
        );
    }

    const statusFormatter = (cell, row, rowIndex, formatExtraData) =>
    {
        let color = "#216C06";

        if (cell === "Suspended" || cell === "Expired") {
            color = "#E00909";
        }

        if (cell === "Invited" || cell === "Re-invited") {
            color = "#E1720B";
        }

        return <div style={{ borderRadius: "5px", color: color }}>{cell}</div>;
    }

    const headerStyle = customHeaderStyle.bind(null, {
        default: defaultTableHeaderStyles,
        firstname: {borderRadius: defaultTopLeftCellStyle, width: "12vw"},
        surname: { width: "15vw"},
        username: {width: "15vw"},
        typeName: {width: "12vw"},
        options: {borderRadius: defaultTopRightCellStyle, textAlign: 'right', width: "15vw"}
    });

    const getColumns = () => {
        const columns = [
            {
                dataField: "firstname",
                text: "Firstname",
                headerStyle: headerStyle
            },
            {
                dataField: "surname",
                text: "Surname",
                sort: true,
                headerStyle: headerStyle
            },
            {
                dataField: "username",
                text: "Username",
                headerStyle: headerStyle
            },
            {
                dataField: "description",
                text: "Short Name",
                headerStyle: headerStyle
            },
            {
                dataField: "typeName",
                text: "User Type",
                formatter: statusFormatter,
                headerStyle: headerStyle
            },
            {
                dataField: "formatted_date",
                text: "Date Archived",
                formatter: statusFormatter,
                headerStyle: headerStyle
            },
            {
                dataField: "options",
                text: "Options",
                formatter: linkFormatter,
                align: 'right',
                headerStyle: headerStyle
            },
        ];

        return columns;
    };

    const translations = xlateBootstrapTableColumns(getColumns());
    const columns = React.useMemo(() => translations, []);

    const thisTableContent = () =>
    {
        return <PassportTable data={props.data} columns={columns} pagination={defaultPaginationOptions}/>
    }

    return props.loading === true ? <SpinnerDiv/> : thisTableContent();
};

export default ArchiveUsersTable;

ArchiveUsersTable.propTypes = {
    user_id: PropTypes.string,
    data: PropTypes.array,
    loading: PropTypes.bool
};
